export const Types = {
    Date: 'Date',
    Region: 'Region',
    Location: 'Location',
};
